<div class="app-global-messages">
    <div *ngFor="let message of messages" [ngClass]="{ 'app-global-message': true, error: message.type == messageType.Error, warning: message.type == messageType.Warning, success: message.type == messageType.Success, 'message-close': message.closed }">
        <div class="app-global-message-content">
            <div *ngFor="let m of message.messages">
                <span><i class="fas fa-exclamation-triangle icon-msg"></i>{{m}}</span>
            </div>  
        </div>
        <i class="fa fa-times app-global-message-close icon-remove" (click)="close(message)"></i>
    </div>
</div>